import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export const bdaTime = (d = new Date()) => d.toLocaleTimeString("en-GB", { timeZone: "Atlantic/Bermuda", hour: "2-digit", minute: "2-digit" });
const lateMins = (t) => { const [h, m] = (t || "0:0").split(":").map(Number); return h * 60 + m - (17 * 60 + 30); };

export const LateFeeDialog = ({ child, defaultTime, onClose, onApplied }) => {
  const [time, setTime] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (child) { setTime(defaultTime || bdaTime()); setNote(""); } }, [child, defaultTime]);
  const mins = lateMins(time);
  const apply = async () => {
    setBusy(true);
    try { const { data } = await api.post("/staff/late-fees", { child_id: child.id, pickup_time: time, note }); toast.success(`Late fee $${data.amount.toFixed(2)} added for ${child.name}`); onApplied && onApplied(); onClose(); }
    catch (e) { toast.error(apiErr(e)); }
    setBusy(false);
  };
  return (
    <Dialog open={!!child} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="rounded-2xl" data-testid="late-fee-dialog">
        <DialogHeader><DialogTitle className="font-display text-navy">Late pickup fee · {child?.name}</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Pickup is by 5:30 PM (Berkeley & Prospect in-house). After that it's $5 per minute. The parent is billed in the app and notified.</p>
        <div className="grid grid-cols-2 gap-3">
          <div><Label className="text-xs">Picked up at</Label><Input type="time" value={time} onChange={(e) => setTime(e.target.value)} className="rounded-xl" data-testid="late-fee-time" /></div>
          <div className="rounded-xl bg-coral/10 p-3 text-center" data-testid="late-fee-amount">
            {mins > 0 ? <><p className="font-display font-black text-2xl text-coral">${mins * 5}</p><p className="text-[11px] text-slate-500">{mins} min × $5</p></> : <p className="text-xs text-slate-500 pt-2">No fee — on time</p>}
          </div>
        </div>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Note (optional)" className="rounded-xl" data-testid="late-fee-note" />
        <div className="flex justify-end gap-2">
          <Button variant="outline" className="rounded-full" onClick={onClose}>Cancel</Button>
          <Button disabled={busy || mins <= 0} onClick={apply} className="rounded-full bg-coral text-white font-bold hover:bg-coral/90" data-testid="late-fee-apply">Apply late fee</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
